"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var getHexColor_1 = require("../../services/getHexColor");
var FontAwesomeIcon = require("@fortawesome/react-fontawesome");
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.render = function () {
        var _a = this.props, icon = _a.icon, color = _a.color, restProps = __rest(_a, ["icon", "color"]);
        var hexColor = getHexColor_1.default(color);
        var iconProp = null;
        // If the passed icon prop is a single string
        if (icon && typeof icon === 'string') {
            // If the icon string is designated a filled icon
            if (Icon.filledIconList[icon]) {
                iconProp = ['fas', icon];
            }
            else {
                // Otherwise default to light
                iconProp = ['fal', icon];
            }
        }
        else {
            // Otherwise us the passed prop, likely an array
            iconProp = icon;
        }
        return React.createElement(FontAwesomeIcon, __assign({}, restProps, { icon: iconProp, color: hexColor }));
    };
    Icon.filledIconList = {
        'caret-up': true,
        'caret-down': true,
        check: true,
        minus: true,
        'play-circle': true,
        'stop-circle': true,
        'pause-circle': true,
        'exclamation-circle': true,
        'check-circle': true
    };
    return Icon;
}(React.Component));
exports.default = Icon;
//# sourceMappingURL=Icon.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Icon/Icon.js
// module id = 12
// module chunks = 0